import {ColDef} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import AGGridMultiChoiceCellEditor from "@/components/inputs/AGGridMultiChoiceCellEditor.vue";
import GUIUtilities from "@/utils/common/GUIUtilities.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import AGGridMultiChoiceRenderer from "@/components/inputs/AGGridMultiChoiceRenderer.vue";
import Translator from "@/utils/common/Translator.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;
import FieldMetaData = namaTypes.FieldMetaData;
import EntityReferenceData = namaTypes.EntityReferenceData;

export default class AGGridEditViewMultiChoiceColumn extends AbsAGGridEditViewColumn
{
  private readonly customMetadata: FieldMetaData | undefined;

  constructor(column: EditScreenGridColumn, handler: EditableGridHandler, columnMetadata?: FieldMetaData) {
    super(column, handler);
    if (columnMetadata)
      this.customMetadata = columnMetadata;
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = AGGridMultiChoiceRenderer;
    colDef.cellEditor = AGGridMultiChoiceCellEditor;
    colDef.cellEditorParams = {
      allowedValues: this.getAllowedValues(),
      enumTypeName: this.columnMetadata.enumTypeName
    };
    colDef.valueFormatter = (params) => {
      return Translator.translate(params.value, this.columnMetadata.enumTypeName) ?? '';
    };
    colDef.cellRendererParams = {
      metaData: this.columnMetadata,
    }
    if (this.customMetadata && this.id.endsWith("." + CommonFieldIds.ENTITY_TYPE)) {
      colDef.context = this.customMetadata;
      colDef.valueSetter = (event) => {
        let genRefFieldId = this.id.substring(0, this.id.lastIndexOf("."));
        let value: EntityReferenceData;
        if (!event.newValue)
          value = {};
        else
          value = {
            entityType: event.newValue
          };
        NamaCommon.setFieldValue(this.handler.object, genRefFieldId, value, event.node?.rowIndex!);
        return true;
      }
    }
    return [colDef];
  }

  getAllowedValues() {
    return GUIUtilities.getAllowedValues(this.handler.entityType, this.columnMetadata);
  }

  override get columnMetadata(): any {
    return this.customMetadata ? this.customMetadata : super.columnMetadata;
  }
}
